module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ["sidebar", "sidebar--contentful", ("sidebar--" + _vm.currentRouteName)]
  }, [_c('div', {
    staticClass: "group group--df-column"
  }, [(!_vm.tree.length) ? _c('h1', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (!_vm.tree.length) ? _c('p', {
    staticClass: "p"
  }, [_vm._v("Life can be hard sometimes. Here you can find support for a variety of challenges we all encounter in life.")]) : _vm._e(), _vm._v(" "), (_vm.tree.length) ? _c('ul', {
    staticClass: "breadcrumbs"
  }, [_c('li', {
    staticClass: "breadcrumbs__item breadcrumbs__item--first"
  }, [_c('router-link', {
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "to": {
        name: 'topics'
      }
    }
  }, [_vm._v("All topics")])], 1), _vm._v(" "), _vm._l((_vm.tree), function(link) {
    return _c('li', {
      key: link.name,
      class: ["breadcrumbs__item", _vm.$route.name === link.name ? "disabled" : ""]
    }, [_c('a', {
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      on: {
        "click": function($event) {
          return _vm.navigateTo(link)
        }
      }
    }, [_vm._v(_vm._s(link.title))])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.tree.length) ? _c('ul', {
    staticClass: "sidebar__nav fs0 mt"
  }, _vm._l((_vm.categoriesToShow), function(category) {
    return _c('li', {
      key: category.id,
      class: [
        "sidebar__nav--item",
        _vm.activeSection === category.slug ? 'fw-bold sidebar__nav--item-active' : '' ],
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      on: {
        "click": function($event) {
          return _vm.scrollToSection(category.slug)
        }
      }
    }, [_vm._v("\n        " + _vm._s(category.name) + "\n      ")])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381fa2c6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ArticleSidebar.vue
// module id = 563
// module chunks = 0